/**
 * Text utility functions
 */
const KNOWN_WORDS_MAPPING = {
    Ano: "Año",
    Obj: "Objetivo",
    Rtdo: "Resultado",
};
/**
 * Convert snake_case field names to readable labels
 */
export function prettifyLabel(name) {
    const parsed = simplePrettifyLabel(name);
    return replaceWords(parsed, KNOWN_WORDS_MAPPING);
}
/**
 * Replace known words in text
 */
export function replaceWords(text, replacements) {
    return Object.entries(replacements).reduce((acc, [key, value]) => acc.replace(new RegExp(`\\b${key}\\b`, "g"), value), text);
}
/**
 * Convert snake_case field names to readable labels (simple version)
 */
export function simplePrettifyLabel(name) {
    return name.replace(/[._-]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}
/**
 * Capitalize first letter of text
 */
export function capitalize(text) {
    if (text.length === 0)
        return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
}
